import { OdooMultiRelationship } from './odoo-multi-relationship.model';
import { IConnectable, TrelloCardEntry2 } from './trello-card';
import { OdooModel } from './odoo-model.model';
import { StockMoveLine } from './stock-move-line';
import { StockMove } from './stock-move';
import { DriveFolder } from './drive.folder';

export class MrpProduction extends OdooModel implements IConnectable<MrpProduction> {
  public readonly ODOO_MODEL = 'mrp.production';
  
  // public readonly ODOO_MODEL = 'sale.order';
  // // public readonly ORDER_TYPE = SaleOrder;
  public readonly ORDER_TYPE_NAME = 'Production';
  // public readonly ORDER_LINE_TYPE = SaleOrderLine;
  
  // id: number;
  // confirmation_date: string;
  // create_ddt: boolean;
  // ddt_ids: OdooMultiRelationship<any>;
  // incoterm: OdooRelationship;
  // order_line: OdooMultiRelationship<SaleOrderLine>;
  // parcels: number;
  // payment_note: string;
  // reference: string;
  // signature: boolean;
  // volume: number;
  // weight: number;
  // trello_ids: OdooMultiRelationship<TrelloCardEntry2> = new OdooMultiRelationship(TrelloCardEntry2)
  // drive_link_docs: string = ""
  // drive_link_project: string = "";
  move_finished_ids:OdooMultiRelationship<StockMove>= new OdooMultiRelationship<StockMove>(StockMove);
  state:string = ""
  move_raw_ids: OdooMultiRelationship<StockMove> = new OdooMultiRelationship<StockMove>(StockMove);
  name: string = ""
  drive_ids: OdooMultiRelationship<DriveFolder>;
  trello_ids: OdooMultiRelationship<TrelloCardEntry2> ;
  origin:string = ""
  title:string = "" // custom
  components_availability_state:boolean = false;
  date_planned_start:string =""
  create() {
    return new MrpProduction()
  }


}
